<template>
  <div class="episode-info">
    <b-headline type="h1" typography="h1" class="episode-info__episode-title mb-2">
      <span class="text-base text-mid-grey font-medium block mb-2 m:mb-6">
        {{ $t("prefix") }}
      </span>
      <span class="block mb-4" v-html="episodeTitle" />
      <span class="block text-h5">
        {{ shortcastTitle }}
      </span>
    </b-headline>

    <b-headline type="h2" typography="h6" class="episode-info__shortcast-tagline mt-0 mb-6">
      {{ shortcastTagline }}
    </b-headline>
    <p class="episode-info__key-insight mb-8" v-html="episodeDescription" />
  </div>
</template>

<script>
import BHeadline from "@/component-library/b-headline"

export default {
  name: "EpisodeInfo",
  components: {
    BHeadline
  },
  props: {
    episodeTitle: {
      type: String,
      required: true
    },
    shortcastTitle: {
      type: String,
      required: true
    },
    shortcastTagline: {
      type: String,
      required: true
    },
    episodeDescription: {
      type: String,
      required: true
    }
  },
  i18n: {
    messages: {
      en: {
        prefix: "Better than a summary:"
      },
      de: {
        prefix: "Zusammenfassung von"
      }
    }
  }
}
</script>

<style lang="scss">
.episode-info {
  &__key-insight {
    @include font-style(p1);
  }
}
</style>
